<nav class="navbar shadow navbar-expand-md navbar-light bg-white" style="margin-top: 25px;">
  <div class="container-fluid align-items-center">

    <div class="col-2">
      <img (click)="toggleLanguage()" class="img-fluid changelang" src="/assets/changeLanguage.png" />
    </div>

    <a class="col-4" routerLink="/Home.mobile">
      <img src="/assets/logo-mobile.png" class="card-img w-25" height="30" />
    </a>

    <button class="navbar-toggler mobile-menu-btn" type="button" (click)="openMenuToggle()">
      <i class="fa-solid fa-bars"></i>
    </button>

  </div>
</nav>


<div *ngIf="openMenu" class="popup">

  <div class="maindev">

    <button (click)="close()" class="close btn btn-primary">
      {{ "close" | transloco }}
    </button>

    <div class="mobile-menu">

      <ul class="navbar-nav ms-auto col-12 col-md-6 justify-content-end">

        <ng-container *ngIf="tokenExists">

          <li class="nav-item" *ngFor="let item of menuItems" (click)="close()" [routerLink]="item.route"
            routerLinkActive="active">

            <img [src]="'/assets/' + item.icon" class="imagessize" [routerLink]="item.route" />

            <a class="text-decoration-none nav-link" [routerLink]="item.route" routerLinkActive="active">

              {{ item.label | transloco }}

            </a>

          </li>
          <li class="nav-item cart" (click)='close()' routerLink="/Addorder">
            <span *ngIf="cartItemCount > 0" style="font-weight: bolder;">
              {{cartItemCount}}</span>
            <img src="/assets/cart.png" class="imagessize" routerLink="/Addorder" [alt]="'add item' | transloco" />

            <a routerLink="/Addorder" class="text-decoration-none nav-link" routerLinkActive="active">{{ "Cart" |
              transloco }}</a>
          </li>


          @if (tokenExists) {
          <li class="nav-item" (click)="logout()">
            <img src="/assets/log out 1.png" alt="" class="imagessize" />
            <a class="text-decoration-none nav-link">{{ "Log out" | transloco }}</a>
          </li>
          }
        </ng-container>

      </ul>

    </div>
  </div>
</div>
